import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Caption } from '@components/styles/Typography';
import { NewButton } from '@components/ui/index';

const NullProductCard = ({ buttonTitle, photo, text }) => {
    const router = useRouter();

    const goHomePage = () => {
        router.push('/wholesale-clothing');
    };

    return (
        <CardWrapper data-testid="null-product-card">
            <CardSupWrapper>
                <CartContainer>
                    <CartNullImage src={photo} />
                    <CartNullTextWrapper>
                        <Caption>{text}</Caption>
                    </CartNullTextWrapper>
                </CartContainer>
                <NewButton
                    size="xlarge"
                    type="primary"
                    handleClick={goHomePage}
                    content={buttonTitle}
                />
            </CardSupWrapper>
        </CardWrapper>
    );
};
export const CardWrapper = styled.div`
    width: 100%;
    max-width: 1080px;
    padding: 10px;
    border: ${({ theme }) => `1px solid ${theme.colors.bgGray10}`};
    margin-top: 15px;
    @media (max-width: 1024px) {
        padding: 0;
        border: none;
        justify-content: center;
        margin-top: 30px;
    }
`;

export const CardSupWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.secondary};
    padding: 20px;
    text-align: center;

  button {
    display: ${({ Hide }) => Hide && 'none'};
  }
  
  div{
    width: 100%;
  }
  
    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 20px;
    }
`;
export const CartContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    gap: 10px;

    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 40px;
        margin-bottom: 30px;
    }
`;

export const CartNullImage = styled.img`
    width: 60px;
`;
export const CartNullTextWrapper = styled.h3`
    text-align: center;

    @media (max-width: 1024px) {
        margin-left: 0;
    }
`;

export default NullProductCard;
